import api from "../../api/api";

export const fetchAllContentStats = () => {
  return api.get("/getAllContentCountInMis");
};
